/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { SearchOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import StoreCard, { StoreFrontIllustration } from "./components/StoreCard";
import OfferCard from "../../components/OfferCard";

const DrawerSearchContent = ({
  classes,
  brandList,
  mailList,
  categoryList,
  onFavouriteToggle,
  onFavouriteMailToggle,
  onUnsubscribeMail,
  onOfferCardClick,
  subscribeshow,
  setSubscribeShow,
  onClose,
  onCatSelect,
  onSelect,
  selBrand,
  showDrawer,
}) => {
  const options = ["Brands", "Categories", "Mails"];
  const [option, setOption] = useState(options[0]);
  const [searchValue, setSearchValue] = useState("");

  const onOptionChange = (value) => {
    setOption(value);
    setSearchValue("");
  };

  return (
    <div css={classes.searchBrandsContainer}>
      <div css={classes.searchPanel}>
        <div css={classes.searchPanelHeader}>
          <IconButton aria-label="back" size="small" onClick={showDrawer}>
            <ArrowBackIosIcon sx={{ fontSize: "1rem" }} />
          </IconButton>
          <span className="backLabel">Search</span>
        </div>

        <div css={classes.searchWrapper}>
          <SearchOutlined sx={classes.searchIcon} />
          <input
            css={classes.search}
            placeholder={`Search ${option}`}
            value={searchValue}
            autoFocus
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>

        <div css={classes.searchTabsWrapper}>
          {options.map((opt) => (
            <div
              key={opt}
              role="button"
              tabIndex={0}
              css={opt === option ? classes.searchTabPillActive : classes.searchTabPill}
              onClick={() => onOptionChange(opt)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onOptionChange(opt);
                }
              }}
            >
              {opt}
            </div>
          ))}
        </div>

        <div css={classes.brandCardsInSearchWrapper}>
          {option === options[0] ? (
            <>
              {brandList
                .filter((item) => {
                  if (!searchValue) return true;
                  return item?.company_name
                    ?.toLowerCase()
                    .startsWith(searchValue?.toLowerCase());
                })
                .map((item) => (
                  <StoreCard
                    key={item?.uuid}
                    item={item}
                    selBrand={selBrand}
                    classes={classes}
                    onBrandSelect={onSelect}
                    onFavouriteToggle={onFavouriteToggle}
                    onAfterSelect={showDrawer}
                  />
                ))}
            </>
          ) : option === options[1] ? (
            <>
              {categoryList
                .filter((item) => {
                  if (!searchValue) return true;
                  return item?.name
                    ?.toLowerCase()
                    ?.includes(searchValue?.toLowerCase());
                })
                .map((item) => (
                  <div
                    key={item?.uuid}
                    role="button"
                    tabIndex={0}
                    css={classes.brandCard}
                    style={{ width: "150px", cursor: "pointer" }}
                    onClick={() => {
                      onCatSelect("", item?.uuid);
                      showDrawer();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onCatSelect("", item?.uuid);
                        showDrawer();
                      }
                    }}
                  >
                    <div css={classes.storeHeader} />
                    <div css={classes.storeImageArea}>
                      {item?.image ? (
                        <img
                          src={item.image}
                          alt={item.name}
                          css={classes.storeImg}
                        />
                      ) : (
                        <StoreFrontIllustration size={64} />
                      )}
                    </div>
                    <div css={classes.storeCardBody}>
                      <span css={classes.storeCardBodyName}>{item?.name}</span>
                    </div>
                  </div>
                ))}
            </>
          ) : (
            <>
              {mailList?.length > 0 ? (
                mailList
                  .filter((item) => {
                    if (!searchValue) return true;
                    return item?.subject
                      ?.toLowerCase()
                      ?.includes(searchValue?.toLowerCase());
                  })
                  .map((item) => {
                    if (!item?.is_active) return null;
                    // Resolve the index within the full (unfiltered) mailList
                    // so next/prev navigation inside the opened offer card
                    // still lines up, regardless of the local search filter.
                    const fullIndex = mailList.findIndex(
                      (m) => m?.uuid === item?.uuid,
                    );
                    return (
                      <OfferCard
                        key={item?.uuid}
                        isRedeemed={item?.is_seen === "true"}
                        item={item}
                        UnsubscribeMailClick={() => onUnsubscribeMail(item)}
                        show={subscribeshow}
                        setShow={(e1) => setSubscribeShow(e1)}
                        showUnSuscribe={true}
                        isFavourite={item?.is_favourite === "true"}
                        onFavouriteMailToggle={(e) =>
                          onFavouriteMailToggle(e, item?.uuid, item)
                        }
                        isLocation={() => {}}
                        message={item?.message}
                        onClick={() => onOfferCardClick(item, fullIndex)}
                      />
                    );
                  })
              ) : (
                <span css={classes.categoryText}>No Mails Available</span>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DrawerSearchContent;
